import { render, staticRenderFns } from "./posPoint.vue?vue&type=template&id=c8a81dbe&scoped=true"
import script from "./posPoint.vue?vue&type=script&lang=js"
export * from "./posPoint.vue?vue&type=script&lang=js"
import style0 from "./posPoint.vue?vue&type=style&index=0&id=c8a81dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a81dbe",
  null
  
)

export default component.exports